import * as THREE from "three";

export const HeatMapDot = ({ position, userData }) => {
	// Determine if shot was made or missed
	const isMadeShot = userData.field_goal_result === "score";

	// Made shot: Green circle mesh
	const MadeShotMesh = () => (
		<mesh position={position} rotation={[Math.PI / 2, 0, Math.PI / 4]}>
			<circleGeometry args={[0.16, 16]} />
			<meshBasicMaterial
				color="#21C651"
				transparent={true}
				opacity={0.9}
				side={THREE.DoubleSide}
			/>
		</mesh>
	);

	// Missed shot: Red X mesh using two rotated rectangles
	const MissedShotMesh = () => (
		<group position={position}>
			{/* First bar of the X */}
			<mesh rotation={[Math.PI / 2, 0, Math.PI / 4]}>
				<planeGeometry args={[0.4, 0.12]} />
				<meshBasicMaterial
					color="#A5A5A5"
					transparent={true}
					opacity={0.9}
					side={THREE.DoubleSide}
				/>
			</mesh>
			{/* Second bar of the X */}
			<mesh rotation={[Math.PI / 2, 0, -Math.PI / 4]}>
				<planeGeometry args={[0.4, 0.12]} />
				<meshBasicMaterial
					color="#A5A5A5"
					transparent={true}
					opacity={0.9}
					side={THREE.DoubleSide}
				/>
			</mesh>
		</group>
	);

	return isMadeShot ? <MadeShotMesh /> : <MissedShotMesh />;
};
